<template>
  <div>
    <div class="hide-on-print">
      <page-title
        icon="fa fa-file-alt"
        main="Relatórios"
        sub="Agendamentos"
      />

      <card>
        <div slot="header" class="row align-items-center">
          <div class="col">
            <h5 class="h3 mb-0">Filtros</h5>
            <h6 class="text-uppercase text-muted ls-1 mb-1">
              Configure quais dados deverão ser listados:
            </h6>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3 col-sm-12"
            v-show="this.$currentUser().is_admin && this.$currentUser().is_manager"
          >
            <label class="form-control-label">Autor</label>
            <multiselect
              v-model="user"
              :options="users"
              placeholder="Nome do autor"
              label="name"
              track-by="id"
              @search-change="filterUsers"
            />
          </div>
          <div class="col-md-3 col-sm-12"
            v-show="
              this.$currentUser().is_admin && this.$currentUser().is_manager
            "
          >
            <label class="form-control-label">Gerente Comercial</label>
            <multiselect
              v-model="filter.manager"
              :options="filter.managers"
              placeholder="Escolha um Gerente Comercial"
              label="name"
              track-by="id"
              @search-change="filterManagers"
              :loading="loading.managers"
            />
          </div>
          <div class="col-md-3 col-sm-12">
            <label class="form-control-label">Vendedor</label>
            <multiselect
              v-model="filter.salesman"
              :options="salesmans"
              :disabled="
                !(
                  currentUser.is_admin ||
                  currentUser.is_manager ||
                  currentUser.has_coordinateds
                )
              "
              @input="handleInputSalesman"
              @search-change="initSalesman"
              placeholder="Escolha um vendedor"
              label="name"
              track-by="id"
              :loading="loading.salesmans"
            />
          </div>
          <div class="col-md-3 col-sm-12">
            <label class="form-control-label">Cliente</label>
            <multiselect
              placeholder="Escolha um Cliente"
              v-model="filter.client"
              :options="filter.clients"
              :loading="loading.clients"
              @search-change="filterClients"
              label="razao_social"
              track-by="id"
              @input="handleInputClients"
            />
          </div>
        </div>
        <div slot="footer" class="row justify-content-end mr-1">
          <base-button type="secondary" class="mr-2 mt-2" @click="clearFilters">Limpar Filtros</base-button>
          <base-button type="secondary" class="mr-2 mt-2" @click="generatePDF">Gerar PDF</base-button>
          <base-button type="secondary" class="mt-2" @click="exportToExcel">Gerar Excel</base-button>
          <base-button
            type="primary"
            class="ml-2 mt-2"
            @click="generateReport"
            v-loading="isLoading"
          >Gerar Relatório</base-button>
        </div>
      </card>
    </div>

    <card v-show="reports_schedule.length" ref="report" v-loading="isLoading">
      <div class="col hide-on-print">
        <h5 class="h3 mb-0">Relatório</h5>
        <h6 class="text-uppercase text-muted ls-1 mb-1">
          Agendamentos
        </h6>
      </div>

      <el-table
        :data="reports_schedule"
        class="table-responsive table-striped"
        header-row-class-name="thead-light"
      >
        <el-table-column
          width="450"
          label="cliente"
          prop="client.name"
          sortable
        />
        <el-table-column
          width="240"
          label="Data"
          prop="date_start"
          sortable
          v-slot="{ row }"
        >
          {{ row.date_start | formatDate }}
        </el-table-column>

        <el-table-column width="400" label="Endereço" prop="address" sortable>
        </el-table-column>

        <el-table-column width="400" label="Usuário" prop="user.name">
        </el-table-column>
      </el-table>
      <br />
      <br />
      <br />
      <div class="card-footer py-4 d-flex justify-content-end">
        <base-pagination
          v-on:input="changePage"
          v-model="paginated_data['current']"
          :total="paginated_data['count']"
          :perPage="paginated_data['per_page']"
        >
        </base-pagination>
      </div>
    </card>
  </div>
</template>

<script>
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";
import { DatePicker } from "element-ui";
import { Table, TableColumn } from "element-ui";
import LineChart from "@/components/Charts/LineChart";
import PageTitle from "@/layouts/PageTitle";

export default {
  components: {
    Multiselect,
    LineChart,
    [TableColumn.name]: TableColumn,
    [Table.name]: Table,
    [DatePicker.name]: DatePicker,
    PageTitle,
  },
  data() {
    return {
      active: true,
      isLoading: false,
      user: {},
      users: [],
      paginated_data: [],
      filter: {
        manager: {},
        managers: [],
        salesman: {},
        client: {},
        clients: [],
      },
      salesmans: [],
      reports_schedule: [],
      loading: {
        salesmans: false,
        managers: false,
        clients: false
      },
    };
  },
  watch: {
    "user": function() {
      if (this.user && this.user.id) {
        this.initSalesman();
        this.filterManagers();
        this.filterClients();
      } else {
        this.filter.salesman = {};
      }
    },
    "filter.manager": function () {
      if (this.$can("index", "user")) {
        this.initSalesman();
      }
      if (this.$can("index", "client")) {
        this.filterClients("");
      }
    },
  },
  async mounted() {
    this.currentUser = this.$currentUser();

    if (this.$can("index", "user")) {
      this.initSalesman();
    }
    if (this.$can("index", "client")) {
      this.filterClients("");
    }
    if (this.$can("index", "user")) {
      this.filterUsers("");
    }
    if (this.currentUser.is_admin) {
      this.filterManagers("");
    } else if (
      this.currentUser.is_manager ||
      this.currentUser.has_coordinateds
    ) {
      this.filter.managers = [this.currentUser];
      this.filter.salesmans = this.currentUser.salesmans;
      this.filter.manager = this.currentUser;
    } else if (this.currentUser.is_salesman) {
      this.filter.managers = [this.currentUser.manager];
      this.filter.salesmans = [this.currentUser];
      this.filter.manager = this.currentUser.manager;
      this.filter.salesman = this.currentUser;
      this.filterClients("");
    }
    this.generateReport();
  },
  methods: {
    generatePDF() {
      window.print();
    },
    exportToExcel() {
      return this.$exportToExcel();
    },
    handleInputSalesman(){
      this.filterClients('');
    },
    handleInputClients(){
      this.initSalesman();
    },
    clearFilters() {
      this.user = {};
      this.filter.manager = {};
      this.filter.salesman = {};
      this.filter.client = {};
      this.salesmans = [];
    },
    async initSalesman(query = '') {
      this.loading.salesmans = true;
      const queryObj = { name: query || '' };

      if (this.filter.manager && this.filter.manager.id) {
        queryObj.manager_id = this.filter.manager.id;
      }

      if (this.filter.anosafra && this.filter.anosafra.id) {
        queryObj.anosafra_id = this.filter.anosafra.id;
      }

      if (this.filter.client && this.filter.client.id) {
        queryObj.client_id = this.filter.client.id;
      }

      try {
        const response = await this.$http.secured.get("/api/v1/users", {
          params: {
            page: 1,
            per_page: 20,
            is_salesman: true,
            q: queryObj
          },
        });
        this.salesmans = response.data && response.data.users || [];
        if (this.filter.salesman && !this.salesmans.some(s => s.id === this.filter.salesman.id)) {
          this.filter.salesman = {};
        }
      } catch (error) {
        console.warn("[schedules] - initSalesman", error);
      }
      this.loading.salesmans = false;
    },
    async filterManagers(query = '') {
      this.loading.managers = true;
      const queryObj = { name: query || '' };

      if (this.filter.anosafra && this.filter.anosafra.id) {
        queryObj.anosafra_id = this.filter.anosafra.id;
      }
      if (this.filter.manager && this.filter.manager.length > 0) {
        queryObj.manager_id = this.filter.manager.map((manager) => manager.id);
      }

      try {
        const response = await this.$http.secured.get("/api/v1/users", {
          params: {
            page: 1,
            per_page: 20,
            is_manager: true,
            q: queryObj
          }
        });
        this.filter.managers = response.data && response.data.users || [];

        if (this.filter.manager && !this.filter.managers.some(m => m.id === this.filter.manager.id)) {
          this.filter.manager = {};
        }

      } catch (error) {
        console.warn("[schedules] - filterManagers", error);
      }
      this.loading.managers = false;
    },
    filterUsers() {
      this.$http.secured
        .get(`/api/v1/users`, { params: { name_only: true } })
        .then((response) => {
          this.users = response.data;
        });
    },
    async filterClients(query = '') {
      this.loading.clients = true;
      const data = {
        q: {},
        per_page: 10,
      };

      if (query.trim()) {
        data.q.razao_social = query;
      }

      if (this.filter.salesman && this.filter.salesman.id) {
        data.q.salesman_id = this.filter.salesman.id;
      }

      if (this.filter.manager && this.filter.manager.id)
        data.q.user_id = this.filter.manager.id;

      try {
        const response = await this.$http.secured.get("/api/v1/clients", { params: data });

        this.filter.clients = response.data && response.data.clients || [];

        if (this.filter.client && !this.filter.clients.some(c => c.id === this.filter.client.id)) {
          this.filter.client = {};
        }
      } catch (error) {
        console.warn("[schedules] - filterClients", error);
      } finally {
        this.loading.clients = false;
      }
    },
    changePage(page) {
      let filterInput = null;
      if (this.filtered) filterInput = this.filter;
      this.generateReport(filterInput, page);
    },
    formatDate(dateString) {
      let dateParts = dateString.split(" / ");
      return dateParts.join("-");
    },
    async generateReport( page = null) {
      this.isLoading = true;
      try {
        const params = {
          page: page,
          "schedule[user_id]": (this.filter.manager && this.filter.manager.id) ||  (this.user && this.user.id),
          "schedule[client_id]": this.filter.client ? this.filter.client.id : null,
          "schedule[salesman_id]": this.filter.salesman ? this.filter.salesman.id : null,
        };

        const response = await this.$http.secured.get('/api/v1/report/reports_schedule', { params });

        this.paginated_data = response.data;
        this.reports_schedule = response.data;
        this.lastEdition = new Date();
      } catch (error) {
        console.error('Error generating report:', error);
      } finally {
        this.isLoading = false;
      }
    }
  },
};
</script>